export default require('~/locales/de.json')
